import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export const getAllJenisRawat = async () => {
  try {
    const api = await instance2.get(LIST_URL_MASTER.jenis_rawat.list);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deleteJenisRawatById = async (
  id,
  run,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance2.post(
      LIST_URL_MASTER.jenis_rawat.delete,
      {},
      {
        headers: {
          idtypeofcare: id,
        },
      }
    );
    run(!run);
    setShowModalDeleteConfirm(false);
    setFormData({
      id: "",
      name: "",
      code: "",
    });
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "code",
    disablePadding: false,
    label: "KODE",
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    minWidth: "150px",
    align: "left",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    minWidth: "200px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    minWidth: "200px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    minWidth: "200px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    minWidth: "200px",
  },
];

export const ModalForm = ({ setShowModal, data, run }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const [formData, setFormData] = useState({
    name: data.name,
    code: data.code,
    id: data.id,
  });

  const addPoliklinik = async () => {
    return instance2.post(LIST_URL_MASTER.jenis_rawat.add, {
      ...formData,
    });
  };

  const updatePoliklinik = () => {
    return instance2.post(
      LIST_URL_MASTER.jenis_rawat.update,
      {
        ...formData,
      },
      {
        headers: {
          idtypeofcare: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);

    if (formData.name === "" || formData.code === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama dan Kode tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addPoliklinik();
        } else if (formData.id !== "") {
          await updatePoliklinik();
        }
        run(!run);
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);

        setShowModal(false);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal title={"Tambah Jenis Rawat"} show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='code'
              label='Kode'
              id='code'
              disabled={true}
              value={formData.code}
              onChange={handleChange("code")}
              placeholder='Kode'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='Nama'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Nama'
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
